export default [
  {
    path: "/Role",
    name: "role",
    component: () => import("@/views/Complaint/role/Role.vue"),
    meta: {
      pageTitle: "จัดการสิทธิ์การใช้งานระบบ",
      breadcrumb: [
        {
          text: "สิทธิ์การใช้งาน",
        },
        {
          text: "จัดการสิทธิ์การใช้งานระบบ",
          active: true,
        },
      ],
      menu: 'Role Menu',
    },
  },
  {
    path: "/Role/Manage",
    name: "RoleManage",
    component: () => import("@/views/Complaint/role/RoleManage.vue"),
    meta: {
      pageTitle: "สิทธิ์การใช้งาน",
      breadcrumb: [
        {
          text: "สิทธิ์การใช้งาน",
        },
        {
          text: "จัดการสิทธิ์การใช้งานระบบ",
          active: true,
        },
      ],
    },
  },
  {
    path: "/Role/Menu",
    name: "RoleMenu",
    component: () => import("@/views/Complaint/role/RoleMenu.vue"),
    meta: {
      pageTitle: "สิทธิ์การใช้งาน",
      breadcrumb: [
        {
          text: "สิทธิ์การใช้งาน",
        },
        {
          text: "จัดการสิทธิ์การใช้งานระบบ",
        },
        {
          text: "__",
          active: true,
        },
      ],
    },
  },
  {
    path: "/Role/User",
    name: "RoleUser",
    component: () => import("@/views/Complaint/role/RoleUser.vue"),
    meta: {
      pageTitle: "สิทธิ์การใช้งาน",
      breadcrumb: [
        {
          text: "สิทธิ์การใช้งาน",
        },
        {
          text: "จัดการผู้ใช้งานในกลุ่มสิทธิ์",
        },
        {
          text: "__",
          active: true,
        },
      ],
    },
  },
  {
    path: "/DepartmentRole",
    name: "DepartmentRole",
    component: () => import("@/views/Complaint/DepartmentRole/DepartmentRole.vue"),
    meta: {
      pageTitle: "จัดการสิทธิ์การใช้งานระบบ",
      breadcrumb: [
        {
          text: "สิทธิ์การใช้งาน",
        },
        {
          text: "จัดการสิทธิ์ผู้ใช้งาน",
          active: true,
        },
      ],
      menu: 'Role Menu',
    },
  },
  {
    path: "/DepartmentRole/User",
    name: "DepartmentRoleUser",
    component: () => import("@/views/Complaint/DepartmentRole/DepartmentRoleUser.vue"),
    meta: {
      pageTitle: "จัดการสิทธิ์การใช้งานระบบ",
      breadcrumb: [
        {
          text: "สิทธิ์การใช้งาน",
        },
        {
          text: "จัดการสิทธิ์ผู้ใช้งาน",
        },
        {
          text: "__",
          active: true,
        },
      ],
      menu: 'Role Menu',
    },
  },
  {
    path: "/DepartmentRole/UserProfile",
    name: "DepartmentRoleUserProfile",
    component: () => import("@/views/Complaint/DepartmentRole/DepartmentRoleUserProfile.vue"),
    meta: {
      pageTitle: "จัดการสิทธิ์การใช้งานระบบ",
      breadcrumb: [
        {
          text: "สิทธิ์การใช้งาน",
        },
        {
          text: "จัดการสิทธิ์ผู้ใช้งาน",
        },
        {
          text: "__",
          active: true,
        },
      ],
      menu: 'Role Menu',
    },
  },
  {
    path: "/AssignWorkOrder",
    name: "AssignWorkOrder",
    component: () => import("@/views/Complaint/WorkOrder/AssignWorkOrder.vue"),
    meta: {
      pageTitle: "ตั้งค่า",
      breadcrumb: [
        {
          text: "ตั้งค่า",
        },
        {
          text: "ตั้งค่าลำดับการจ่ายงาน",
          active: true,
        },
      ],
    },
  },

  
  {
    path: "/Master/PurchasePlace",
    name: "MasterPurchasePlace",
    component: () => import("@/views/Complaint/Master/Purchase/PurchasePlace.vue"),
    meta: {
      pageTitle: "ตั้งค่าระบบ",
      breadcrumb: [
        {
          text: "สถานที่ซื้อหรือใช้บริการ",
          active: true,
        },
      ],
    },
  },
  {
    path: "/Master/PurchasePropagate",
    name: "MasterPurchasePropagate",
    component: () => import("@/views/Complaint/Master/Purchase/PurchasePropagate.vue"),
    meta: {
      pageTitle: "ตั้งค่าระบบ",
      breadcrumb: [
        {
          text: "ท่านรับทราบถึงตัวสินค้า หรือบริการผ่านช่องทางใด",
          active: true,
        },
      ],
    },
  },

  {
    path: "/Master/NotifyPurpose",
    name: "MasterNotifyPurpose",
    component: () => import("@/views/Complaint/Master/Purchase/NotifyPurpose.vue"),
    meta: {
      pageTitle: "ตั้งค่าระบบ",
      breadcrumb: [
        {
          text: "การชำระเงิน",
          active: true,
        },
      ],
    },
  },

    {
    path: "/Master/PurchaseMethod",
    name: "MasterPurchaseMethod",
    component: () => import("@/views/Complaint/Master/Purchase/PurchaseMethod.vue"),
    meta: {
      pageTitle: "ตั้งค่าระบบ",
      breadcrumb: [
        {
          text: "การชำระเงิน",
          active: true,
        },
      ],
    },
  },
  {
    path: "/Master/PurchaseManage",
    name: "MasterPurchaseManage",
    component: () => import("@/views/Complaint/Master/Purchase/PurchaseManage.vue"),
    meta: {
      pageTitle: "ตั้งค่าระบบ",
      breadcrumb: [
        {
          text: "จัดการข้อมูล",
          active: true,
        },
      ],
    },
  },

  {
    path: "/Master/ComplaintCategory",
    name: "MasterComplaintCategory",
    component: () => import("@/views/Complaint/Master/Complaint/ComplaintCategory.vue"),
    meta: {
      pageTitle: "ตั้งค่าระบบ",
      breadcrumb: [
        {
          text: "หมวดหมู่เรื่องร้องทุกข์",
          active: true,
        },
      ],
    },
  },
  {
    path: "/Master/ComplaintCategoryManage",
    name: "MasterComplaintCategoryManage",
    component: () => import("@/views/Complaint/Master/Complaint/ComplaintCategoryManage.vue"),
    meta: {
      pageTitle: "ตั้งค่าระบบ",
      breadcrumb: [
        {
          text: "จัดการข้อมูล",
          active: true,
        },
      ],
    },
  },


  {
    path: "/Master/ComplaintType",
    name: "MasterComplaintType",
    component: () => import("@/views/Complaint/Master/Complaint/ComplaintType.vue"),
    meta: {
      pageTitle: "ตั้งค่าระบบ",
      breadcrumb: [
        {
          text: "ประเภทร้องทุกข์",
          active: true,
        },
      ],
    },
  },
  {
    path: "/Master/ComplaintTypeManage",
    name: "MasterComplaintTypeManage",
    component: () => import("@/views/Complaint/Master/Complaint/ComplaintTypeManage.vue"),
    meta: {
      pageTitle: "ตั้งค่าระบบ",
      breadcrumb: [
        {
          text: "จัดการข้อมูล",
          active: true,
        },
      ],
    },
  },

  {
    path: "/Master/ComplaintCause",
    name: "MasterComplaintCause",
    component: () => import("@/views/Complaint/Master/Complaint/ComplaintCause.vue"),
    meta: {
      pageTitle: "ตั้งค่าระบบ",
      breadcrumb: [
        {
          text: "สาเหตุที่ต้องร้องทุกข์",
          active: true,
        },
      ],
    },
  },
  {
    path: "/Master/ComplaintCauseManage",
    name: "MasterComplaintCauseManage",
    component: () => import("@/views/Complaint/Master/Complaint/ComplaintCauseManage.vue"),
    meta: {
      pageTitle: "ตั้งค่าระบบ",
      breadcrumb: [
        {
          text: "จัดการข้อมูล",
          active: true,
        },
      ],
    },
  },
  {
    path: "/Conclusion",
    name: "Conclusion",
    component: () => import("@/views/Complaint/Conclusion/Conclusion.vue"),
    meta: {
      pageTitle: "มติ คคบ",
      breadcrumb: [
        {
          text: "มติ คคบ",
          active: true,
        },
      ],
    },
  },
  {
    path: "/Conclusion/Manage",
    name: "ConclusionManage",
    component: () => import("@/views/Complaint/Conclusion/ConclusionManage.vue"),
    meta: {
      pageTitle: "มติ คคบ",
      breadcrumb: [
        {
          text: "มติ คคบ",
        },
        {
          text: "จัดการมติ คคบ",
          active: true,
        },
      ],
    },
  },
  {
    path: "/Conclusion/Detail",
    name: "ConclusionDetail",
    component: () => import("@/views/Complaint/Conclusion/ConclusionDetail.vue"),
    meta: {
      pageTitle: "มติ คคบ",
      breadcrumb: [
        {
          text: "มติ คคบ",
        },
        {
          text: "มติที่ประชุม",
          active: true,
        },
      ],
    },
  },
  {
    path: "/Conclusion/Detail/Manage",
    name: "ConclusionDetailManage",
    component: () => import("@/views/Complaint/Conclusion/ConclusionDetailManage.vue"),
    meta: {
      pageTitle: "มติ คคบ",
      breadcrumb: [
        {
          text: "มติ คคบ",
        },
        {
          text: "มติที่ประชุม",
        },
        {
          text: "จัดการมติที่ประชุม",
          active: true,
        },
      ],
    },
  },
  {
    path: '/AttachmentHistory',
    name: 'AttachmentHistory',
    component: () => import('@/views/Complaint/AttachmentHistory/AttachmentHistory.vue'),
    meta: {
      pageTitle: 'ประวัติการดำเนินการ',
      breadcrumb: [
        {
          text: 'เอกสาร',
        },
        {
          text: 'ประวัติการดำเนินการ',
          active: true,
        },
      ],
    },
  },
  {
    path: "/Consult",
    name: "Consult",
    component: () => import("@/views/Complaint/Consult/Consult.vue"),
    meta: {
      pageTitle: "การให้คำปรึกษา / แนะนำเรื่องร้องทุกข์ของผู้บริโภค",
      breadcrumb: [
        {
          text: "การให้คำปรึกษา",
          active: true,
        },
      ],
    },
  },
  {
    path: "/Consult/Manage",
    name: "ConsultManage",
    component: () => import("@/views/Complaint/Consult/ConsultManage.vue"),
    meta: {
      pageTitle: "การให้คำปรึกษา / แนะนำเรื่องร้องทุกข์ของผู้บริโภค",
      breadcrumb: [
        {
          text: "การให้คำปรึกษา",
        },
        {
          text: "ให้คำปรึกษา",
          active: true,
        },
      ],
    },
  },
  {
    path: "/ClueSearch",
    name: "ClueSearch",
    component: () => import("@/views/Complaint/clue/cluesearch/ClueSearch.vue"),
    meta: {
      pageTitle: "แจ้งเบาะแส",
      breadcrumb: [
        {
          text: "แจ้งเบาะแส",
        },
        {
          text: "ค้นหา",
          active: true,
        },
      ],
    },
  },
  {
    path: "/ClueSearch/Manage",
    name: "ClueSearchManage",
    component: () => import("@/views/Complaint/clue/cluesearch/ClueSearchManage.vue"),
    meta: {
      pageTitle: "แจ้งเบาะแส",
      breadcrumb: [
        {
          text: "แจ้งเบาะแส",
        },
        {
          text: "ค้นหา",
        },
        {
          text: "ดูรายละเอียด",
          active: true,
        },
      ],
    },
  },
  {
    path: "/ClueCheck",
    name: "ClueCheck",
    component: () => import("@/views/Complaint/clue/cluecheck/ClueCheck.vue"),
    meta: {
      pageTitle: "แจ้งเบาะแส",
      breadcrumb: [
        {
          text: "แจ้งเบาะแส",
        },
        {
          text: "ตรวจสอบ",
          active: true,
        },
      ],
    },
  },
  {
    path: "/ClueCheck/Manage",
    name: "ClueCheckManage",
    component: () => import("@/views/Complaint/clue/cluecheck/ClueCheckManage.vue"),
    meta: {
      pageTitle: "แจ้งเบาะแส",
      breadcrumb: [
        {
          text: "แจ้งเบาะแส",
        },
        {
          text: "ตรวจสอบ",
        },
        {
          text: "จัดการ",
          active: true,
        },
      ],
    },
  },
  {
    path: "/ClueAction",
    name: "ClueAction",
    component: () => import("@/views/Complaint/clue/clueaction/ClueAction.vue"),
    meta: {
      pageTitle: "แจ้งเบาะแส",
      breadcrumb: [
        {
          text: "แจ้งเบาะแส",
        },
        {
          text: "ดำเนินการ",
          active: true,
        },
      ],
    },
  },
  {
    path: "/ClueAction/Manage",
    name: "ClueActionManage",
    component: () => import("@/views/Complaint/clue/clueaction/ClueActionManage.vue"),
    meta: {
      pageTitle: "แจ้งเบาะแส",
      breadcrumb: [
        {
          text: "แจ้งเบาะแส",
        },
        {
          text: "ดำเนินการ",
        },
        {
          text: "จัดการ",
          active: true,
        },
      ],
    },
  },
  {
    path: "/ClueManage",
    name: "ClueManage",
    component: () => import("@/views/Complaint/clue/cluemanage/ClueManage.vue"),
    meta: {
      pageTitle: "แจ้งเบาะแส",
      breadcrumb: [
        {
          text: "แจ้งเบาะแส",
        },
        {
          text: "ดำเนินการ",
        },
        {
          text: "เพิ่มเรื่อง",
          active: true,
        },
      ],
    },
  },
  {
    path: "/ComplaintManage",
    name: "ComplaintManage",
    component: () => import("@/views/Complaint/ComplaintManage/ComplaintManage.vue"),
    meta: {
      pageTitle: "จัดการสถานะเรื่องร้องทุกข์",
      breadcrumb: [
        {
          text: "จัดการสถานะเรื่องร้องทุกข์",
          active: true,
          class: "text-danger"
        },
      ],
    },
  },
  {
    path: "/ComplaintManage/Tracking",
    name: "ComplaintManageTracking",
    component: () => import("@/views/Complaint/ComplaintManage/ComplaintManageTracking.vue"),
    meta: {
      pageTitle: "จัดการสถานะเรื่องร้องทุกข์",
      breadcrumb: [
        {
          text: "จัดการสถานะเรื่องร้องทุกข์",
          class: "text-danger"
        },
        {
          text: "แก้ไขสถานะ",
          active: true,
          class: "text-danger"
        },
      ],
    },
  },
  {
    path: "/DocumentManage",
    name: "DocumentManage",
    component: () => import("@/views/Complaint/DocumentManage/DocumentManage.vue"),
    meta: {
      pageTitle: "จัดการเอกสารระบบร้องทุกข์",
      breadcrumb: [
        {
          text: "จัดการเอกสารระบบร้องทุกข์",
          active: true,
          class: "text-danger"
        },
      ],
    },
  },
  {
    path: "/DocumentManage/Edit",
    name: "DocumentManageEdit",
    component: () => import("@/views/Complaint/DocumentManage/DocumentManageEdit.vue"),
    meta: {
      pageTitle: "จัดการเอกสารระบบร้องทุกข์",
      breadcrumb: [
        {
          text: "จัดการเอกสารระบบร้องทุกข์",
          class: "text-danger"
        },
        {
          text: "แก้ไขสถานะ",
          active: true,
          class: "text-danger"
        },
      ],
    },
  },
  {
    path: "/ComplaintManageNull",
    name: "ComplaintManageNull",
    component: () => import("@/views/Complaint/ComplaintManageNull/ComplaintManageNull.vue"),
    meta: {
      pageTitle: "จัดการสถานะการติดตามเรื่องร้องทุกข์",
      breadcrumb: [
        {
          text: "จัดการสถานะการติดตามเรื่องร้องทุกข์",
          active: true,
          class: "text-danger"
        },
      ],
    },
  },
  {
    path: "/ComplaintManageUserInspect",
    name: "ComplaintManageUserInspect",
    component: () => import("@/views/Complaint/ComplaintManageUserInspect/ComplaintManageUserInspect.vue"),
    meta: {
      pageTitle: "ตรวจสอบผู้ใช้งาน",
      breadcrumb: [
        {
          text: "ตรวจสอบผู้ใช้งาน",
          active: true,
          class: "text-danger"
        },
      ],
    },
  },
  {
    path: "/ComplaintManageNull/Tracking",
    name: "ComplaintManageNullTracking",
    component: () => import("@/views/Complaint/ComplaintManageNull/ComplaintManageNullTracking.vue"),
    meta: {
      pageTitle: "จัดการสถานะการติดตามเรื่องร้องทุกข์",
      breadcrumb: [
        {
          text: "จัดการสถานะการติดตามเรื่องร้องทุกข์",
          class: "text-danger"
        },
        {
          text: "แก้ไขสถานะ",
          active: true,
          class: "text-danger"
        },
      ],
    },
  },
  {
    path: "/ClueAdmin",
    name: "ClueAdmin",
    component: () => import("@/views/Complaint/clue/clueadmin/ClueAdmin.vue"),
    meta: {
      pageTitle: "จัดการสถานะการแจ้งเบาะแส",
      breadcrumb: [
        {
          text: "จัดการสถานะการแจ้งเบาะแส",
          active: true,
          class: "text-danger"
        },
      ],
    },
  },
  {
    path: "/ClueAdmin/Manage",
    name: "ClueAdminManage",
    component: () => import("@/views/Complaint/clue/clueadmin/ClueAdminManage.vue"),
    meta: {
      pageTitle: "จัดการสถานะการแจ้งเบาะแส",
      breadcrumb: [
        {
          text: "จัดการสถานะการแจ้งเบาะแส",
          class: "text-danger"
        },
        {
          text: "แก้ไขสถานะ",
          active: true,
          class: "text-danger"
        },
      ],
    },
  },
  {
    path: "/LogExternalService",
    name: "LogExternalService",
    component: () => import("@/views/Complaint/LogExternalService/LogExternalService.vue"),
    meta: {
      pageTitle: "ข้อมูลการส่งต่อเรื่องร้องทุกข์",
      breadcrumb: [        
        {
          text: "ข้อมูลการส่งต่อเรื่องร้องทุกข์",
          active: true,
          class: "text-danger"
        },
      ],
    },
  },
  {
    path: '/ProvincialOfficer',
    name: 'ProvincialOfficer',
    component: () => import('@/views/Complaint/Provincial/ProvincialOfficer.vue'),
    meta: {
      pageTitle: 'รายการเรื่องร้องทุกข์',
      breadcrumb: [
        {
          text: 'เจ้าหน้าที่ภูมิภาค',
        },
        {
          text: 'รายการเรื่องร้องทุกข์',
          active: true,
        },
      ],
    },
  },
  {
    path: '/BangkokOfficer',
    name: 'BangkokOfficer',
    component: () => import('@/views/Complaint/Bangkok/BangkokOfficer.vue'),
    meta: {
      pageTitle: 'รายการเรื่องร้องทุกข์',
      breadcrumb: [
        {
          text: 'เจ้าหน้าที่ กทม.',
        },
        {
          text: 'รายการเรื่องร้องทุกข์',
          active: true,
        },
      ],
    },
  },
  
  {
    path: '/ProvincialOfficer/Manage',
    name: 'ProvincialOfficerManage',
    component: () => import('@/views/Complaint/Provincial/ProvincialOfficerManage.vue'),
    meta: {
      pageTitle: 'รายการเรื่องร้องทุกข์',
      breadcrumb: [
        {
          text: 'เจ้าหน้าที่ภูมิภาค',
        },
        {
          text: 'รายการเรื่องร้องทุกข์',
        },
        {
          text: 'จัดการเรื่องร้องทุกข์',
          active: true,
        },
      ],
    },
  },
  {
    path: '/BangkokOfficer/Manage',
    name: 'BangkokOfficerManage',
    component: () => import('@/views/Complaint/Bangkok/BangkokOfficerManage.vue'),
    meta: {
      pageTitle: 'รายการเรื่องร้องทุกข์',
      breadcrumb: [
        {
          text: 'เจ้าหน้าที่ กทม.',
        },
        {
          text: 'รายการเรื่องร้องทุกข์',
        },
        {
          text: 'จัดการเรื่องร้องทุกข์',
          active: true,
        },
      ],
    },
  },
  {
    path: '/AppLog',
    name: 'AppLog',
    component: () => import('@/views/Complaint/AppLog/AppLog.vue'),
    meta: {
      pageTitle: 'ประวัติการใช้งาน',
      breadcrumb: [
        {
          text: 'ประวัติการใช้งาน',
          active: true,
        },
      ],
    },
  },
  {
    path: "/FastTrack/UserInspect",
    name: "FasttrackUserInspect",
    component: () => import("@/views/Complaint/FasttrackUserInspect/FasttrackUserInspect.vue"),
    meta: {
      pageTitle: "ตรวจสอบผู้ใช้งาน",
      breadcrumb: [
        {
          text: "ตรวจสอบผู้ใช้งาน",
          active: true,
          class: "text-danger"
        },
      ],
    },
  },
  {
    path: "/FastTrack/UserInspect/Attorney",
    name: "FasttrackUserInspectAttorney",
    component: () => import("@/views/Complaint/FasttrackUserInspect/FasttrackUserInspectAttorney.vue"),
    meta: {
      pageTitle: "ผู้รับมอบอำนาจ",
      breadcrumb: [
        {
          text: "ตรวจสอบผู้ใช้งาน",
        },
        {
          text: "ผู้รับมอบอำนาจ",
          active: true,
          class: "text-danger"
        },
      ],
    },
  },
  {
    path: '/FastTrack/TransactionLog',
    name: 'FastTrackTransactionLog',
    component: () => import('@/views/Complaint/AppFasttrackLog/TransactionLog.vue'),
    meta: {
      pageTitle: 'ขั้นตอนการทํางานที่สําคัญ',
      breadcrumb: [
        {
          text: 'ขั้นตอนการทํางานที่สําคัญ',
          active: true,
        },
      ],
    },
  },
  {
    path: '/FastTrack/ErrorLog',
    name: 'FastTrackErrorLog',
    component: () => import('@/views/Complaint/AppFasttrackLog/ErrorLog.vue'),
    meta: {
      pageTitle: 'ขั้นตอนเมื่อระบบเกิดข้อผิดพลาด',
      breadcrumb: [
        {
          text: 'ขั้นตอนเมื่อระบบเกิดข้อผิดพลาด',
          active: true,
        },
      ],
    },
  },
  {
    path: '/FastTrack/AuthenticationLog',
    name: 'FastTrackAuthenticationLog',
    component: () => import('@/views/Complaint/AppFasttrackLog/AuthenticationLog.vue'),
    meta: {
      pageTitle: 'ขั้นตอนการยืนยันตัวตน',
      breadcrumb: [
        {
          text: 'ขั้นตอนการยืนยันตัวตน',
          active: true,
        },
      ],
    },
  },
  {
    path: "/LawConsult",
    name: "LawConsult",
    component: () => import("@/views/Complaint/LawConsult/LawConsult.vue"),
    meta: {
      pageTitle: "ปรึกษากฏหมาย",
      breadcrumb: [
        {
          text: "ปรึกษากฏหมาย",
          active: true,
        },
      ],
    },
  },
  {
    path: "/LawConsult/Manage",
    name: "LawConsultManage",
    component: () => import("@/views/Complaint/LawConsult/LawConsultManage.vue"),
    meta: {
      pageTitle: "ปรึกษากฏหมาย",
      breadcrumb: [
        {
          text: "ปรึกษากฏหมาย",
        },
        {
          text: "ให้คำปรึกษา",
          active: true,
        },
      ],
    },
  },
  {
    path: "/Master/InternalDepartment",
    name: "InternalDepartment",
    component: () => import("@/views/Complaint/Master/Department/InternalDepartment.vue"),
    meta: {
      pageTitle: "ตั้งค่าหน่วยงานภายใน",
      breadcrumb: [
        {
          text: "หน่วยงานภายใน",
          active: true,
        },
      ],
    },
  },
  {
    path: "/Master/InternalDepartmentManage",
    name: "InternalDepartmentManage",
    component: () => import("@/views/Complaint/Master/Department/InternalDepartmentManage.vue"),
    meta: {
      pageTitle: "ตั้งค่าหน่วยงานภายใน",
      breadcrumb: [
        {
          text: "หน่วยงานภายใน",
        },
        {
          text: "จัดการหน่วยงานภายใน",
          active: true,
        },
      ],
    },
  },

  {
    path: "/Master/ExternalDepartment",
    name: "ExternalDepartment",
    component: () => import("@/views/Complaint/Master/Department/ExternalDepartment.vue"),
    meta: {
      pageTitle: "ตั้งค่าหน่วยงานภายนอก",
      breadcrumb: [
        {
          text: "หน่วยงานภายนอก",
          active: true,
        },
      ],
    },
  },

  {
    path: "/Master/ExternalDepartmentManage",
    name: "ExternalDepartmentManage",
    component: () => import("@/views/Complaint/Master/Department/ExternalDepartmentManage.vue"),
    meta: {
      pageTitle: "ตั้งค่าหน่วยงานภายนอก",
      breadcrumb: [
        {
          text: "หน่วยงานภายนอก",
        },
        {
          text: "จัดการหน่วยงานภายนอก",
          active: true,
        },
      ],
    },
  },

  {
    path: "/Master/SystemDepartment",
    name: "SystemDepartment",
    component: () => import("@/views/Complaint/Master/Department/SystemDepartment.vue"),
    meta: {
      pageTitle: "ตั้งค่าระบบหน่วยงาน",
      breadcrumb: [
        {
          text: "ระบบหน่วยงาน",
          active: true,
        },
      ],
    },
  },
  {
    path: "/Master/SystemDepartmentManage",
    name: "SystemDepartmentManage",
    component: () => import("@/views/Complaint/Master/Department/SystemDepartmentManage.vue"),
    meta: {
      pageTitle: "ตั้งค่าระบบหน่วยงาน",
      breadcrumb: [
        {
          text: "ระบบหน่วยงาน",
        },
        {
          text: "จัดการระบบหน่วยงาน",
          active: true,
        },
      ],
    },
  },
  {
    path: "/Verify",
    name: "Verify",
    component: () => import("@/views/Complaint/Verify/Verify.vue"),
    meta: {
      pageTitle: "ระบบออกตรวจผู้ประกอบธุรกิจ",
      breadcrumb: [
        {
          text: "ระบบออกตรวจผู้ประกอบธุรกิจ",
          active: true,
        },
      ],
      menu: 'Role Menu',
    },
  },
  {
    path: "/Verify/Manage",
    name: "VerifyManage",
    component: () => import("@/views/Complaint/Verify/VerifyManage.vue"),
    meta: {
      pageTitle: "ระบบออกตรวจผู้ประกอบธุรกิจ",
      breadcrumb: [
        {
          text: "ระบบออกตรวจผู้ประกอบธุรกิจ",
        },
        {
          text: "จัดการข้อมูลออกตรวจผู้ประกอบธุรกิจ",
          active: true,
        },
      ],
    },
  },
  {
    path: "/Master/ComplaintChannel",
    name: "MasterComplaintChannel",
    component: () => import("@/views/Complaint/Master/Complaint/ComplaintChannel.vue"),
    meta: {
      pageTitle: "ตั้งค่าระบบ",
      breadcrumb: [
        {
          text: "ช่องทางร้องทุกข์",
          active: true,
        },
      ],
    },
  },
  {
    path: "/Master/ComplaintChannelManage",
    name: "MasterComplaintChannelManage",
    component: () => import("@/views/Complaint/Master/Complaint/ComplaintChannelManage.vue"),
    meta: {
      pageTitle: "ตั้งค่าระบบ",
      breadcrumb: [
        {
          text: "จัดการช่องทางร้องทุกข์",
          active: true,
        },
      ],
    },
  },
  {
    path: "/ClueAttachment",
    name: "ClueAttachment",
    component: () => import("@/views/Complaint/clue/clueattachment/ClueAttachment.vue"),
    meta: {
      pageTitle: "แจ้งเบาะแส",
      breadcrumb: [
        {
          text: "แจ้งเบาะแส",
        },
        {
          text: "แนบเอกสารเพิ่มเติม",
          active: true,
        },
      ],
    },
  },
  {
    path: "/ClueUpload",
    name: "ClueUpload",
    component: () => import("@/views/Complaint/servicecenter/clueUpload.vue"),
    meta: {
      pageTitle: "แจ้งเบาะแส",
      breadcrumb: [
        {
          text: "แจ้งเบาะแส",
        },
        {
          text: "แนบเอกสารเพิ่มเติม",
          active: true,
        },
      ],
    },
  },
  {
    path: "/Master/WebexToken",
    name: "WebexToken",
    component: () => import("@/views/Complaint/Master/WebexToken/WebexToken.vue"),
    meta: {
      pageTitle: "ตั้งค่า Webex Token",
      breadcrumb: [
        {
          text: "ตั้งค่า Webex Token",
          active: true,
        },
      ],
    },
  },
  {
    path: "/Master/WebexTokenManage",
    name: "WebexTokenManage",
    component: () => import("@/views/Complaint/Master/WebexToken/WebexTokenManage.vue"),
    meta: {
      pageTitle: "Webex Token Manage",
      breadcrumb: [
        {
          text: "Webex Token Manage",
          active: true,
        },
      ],
    },
  },
  {
    path: '/BangkokOfficer/HistoryBangkokDetail',
    name: 'BangkokOfficerHistory',
    component: () => import('@/views/Complaint/Bangkok/BangkokOfficerHistory.vue'),
    meta: {
      pageTitle: 'รายการเรื่องร้องทุกข์',
      breadcrumb: [
        {
          text: 'เจ้าหน้าที่ กทม.',
        },
        {
          text: 'รายการเรื่องร้องทุกข์',
        },
        {
          text: 'จัดการเรื่องร้องทุกข์',
          active: true,
        },
      ],
    },
  },
];
